import { Component, inject, input } from '@angular/core';
import { StyleSheetSpriteComponent } from '@features/styles/style-sheet-sprite/style-sheet-sprite.component';
import { StylesService } from '@features/styles/styles.service';

@Component({
  selector: 'app-hud-button',
  imports: [StyleSheetSpriteComponent],
  templateUrl: './hud-button.component.html',
  styleUrl: './hud-button.component.css',
})
export class HudButtonComponent {
  readonly _stylesService = inject(StylesService);

  kind = input<'PRIMARY' | 'SECONDARY' | 'SUCCESS' | 'DANGER'>('PRIMARY');
  isDisabled = input<boolean>(false);
}
